import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import logoMedical from "../../assets/logo-medical.png";
import martina from "../../assets/martina.png";
import NextButton from "../../components/NextButton";
import PatientAvatar from "../../components/PatientAvatar";
import { useGameTexts } from "../../hooks/useGameTexts";
import { ROUTES } from "../../utils/constants";
import { getScenarioByScreen } from "../../utils/helpers";

function SupertestEnd({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const group = useSelector((state) => state.group);
	const scenarioNum = getScenarioByScreen(location.pathname);
	const { texts, ready } = useGameTexts(group?.game);

	const title = texts["supertest-end.title"] ?? "";
	const content = texts["supertest-end.content"] ?? "";

	if (!ready) {
		return (
			<div className="h-100 d-flex align-items-center justify-content-center bg-internas">
				<div className="txtWhite">Cargando...</div>
			</div>
		);
	}

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} />
				</div>
				<div className="row d-flex justify-content-center align-items-center mt-5 pt-4">
					<div className="col-1"></div>
					<div className="col-4">
						<PatientAvatar gameId={group?.game} defaultSrc={martina} width={350} />
					</div>
					<div className="col-5">
						<div className="ps-5 txt16">
							<div
								className="txt20 bold txt-yellow-light mt-4"
								style={{ lineHeight: "30px" }}
								dangerouslySetInnerHTML={{ __html: title }}
							/>
							<div className="txt-white mt-4" dangerouslySetInnerHTML={{ __html: content }} />
						</div>
					</div>
					<div className="col-1"></div>
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "8vh",
				}}
			>
				<div className="d-flex justify-content-end">
					<NextButton navigateTo={ROUTES.END} />
				</div>
			</div>
		</div>
	);
}

export default injectIntl(SupertestEnd);
